import Vue from 'vue'
import { GET_CONTRACT_TYPES } from '../mutation-types.js'

export const getContractTypes = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('contract_type')
    .then(
      (response) => {
        dispatch(GET_CONTRACT_TYPES, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/contractTypesActions.js